import { ChangeDetectorRef, Component, EventEmitter, Inject, Input, NgZone, OnInit, Output } from '@angular/core';
import { FieldType } from '@ngx-formly/core';
import { CardWidget, HttpServiceSettings, UiEventRaised } from '@cmx/shared/feature/platform-configuration';
import { mapDataWithTemplate } from '@cmx/shared/util/helper-functions';

import { HTTPSERVICESETTINGS } from '@cmx/shared/util/environment-config';
import { FunctionsService } from '@cmx/shared/feature/firestore';
@Component({
  selector: 'cmx-card-widget',
  templateUrl: './card-widget.component.html',
  styleUrls: ['./card-widget.component.scss'],
})
export class CardWidgetComponent extends FieldType implements OnInit {
  @Input() isFormlyField = true;
  @Input() enableCollapse = true;
  @Input() showChipsLabel = true;
  @Input() taskTemplate: any = null;
  @Input() data: { cardContent: CardWidget } = null;

  @Output() raiseCardEvent = new EventEmitter<UiEventRaised>();
  showProperties = false;
  hideTagsOnExpand = true;
  hideTags: boolean;
  showBadgeCount = true;
  constructor(
    private readonly functions: FunctionsService,
    private changeDetectorRef: ChangeDetectorRef,
    @Inject(HTTPSERVICESETTINGS) private httpServiceSettings: HttpServiceSettings,
  ) {
    super();
  }

  ngOnInit(): void {
    if (this.isFormlyField) {
      this.enableCollapse = this.to.enableCollapse;
      this.hideTagsOnExpand = this.to.hideTagsOnExpand;
      this.showBadgeCount = this.to.showBadgeCount;
      this.data = this.to.data || this?.formControl?.value || this.data;
    }
  }

  cardClicked() {
    const eventData: UiEventRaised = {
      isNavigation: false,
      data: this.data,
      eventName: 'CARD_CLICKED',
    };
    this.raiseEvent(eventData);
  }

  async rightIconClick(e) {
    if (this.enableCollapse) {
      if (this.data['shipments'] && !this.data['shipments'].length)
        try {
          this.data['shipments'] = await this.getShipments(this.data['id'] as string);
          if (this.data['shipments'].length) this.data = mapDataWithTemplate(this.data, this.taskTemplate, this.data);
        } catch (e) {
          console.error(e);
        }
      // this.changeDetectorRef.detectChanges();
      this.showProperties = !this.showProperties;
      if (this.hideTagsOnExpand) {
        this.hideTags = !this.hideTags;
      }
    } else {
      const eventData: UiEventRaised = {
        isNavigation: false,
        data: this.data,
        eventName: 'Card_Icon_Clicked',
      };
      this.raiseEvent(eventData);
    }
  }

  async getShipments(taskId: string) {
    const data = { bucket: this.httpServiceSettings.bucketName, parentTaskId: taskId };
    const tasks: any = await this.functions.callFirebaseFunction('getTaskDetails', data);

    if (tasks && tasks.status) {
      const childTasks = tasks.data.filter(doc => doc.collectionName == 'tasks' && doc.parent);
      const childTasksWithReferences = childTasks.map(task => {
        if (!task.end) task.end = 0;
        if (!task.start) task.start = 0;
        task.referenceDocument = tasks.data.find(item => item.id == task.referenceDocument);
        return task;
      });
      return childTasksWithReferences || [];
    } else throw tasks;
  }

  chipClicked(e) {
    console.log(e);
  }

  raiseEvent(data: UiEventRaised) {
    if (this.isFormlyField) {
      this.to.getFieldEvent(data);
    } else {
      this.raiseCardEvent.emit(data);
    }
  }
}
